/**
 * Asks before deleting something that does not come back: a dataset, a case, a fabricated scenario.
 */

import type { ReactNode } from 'react';
import {
	AlertDialog,
	AlertDialogAction,
	AlertDialogCancel,
	AlertDialogContent,
	AlertDialogDescription,
	AlertDialogFooter,
	AlertDialogHeader,
	AlertDialogTitle
} from '@/components/ui/alert-dialog';

interface ConfirmDeleteDialogProps {
	open: boolean;
	title: string;
	children: ReactNode;
	onOpenChange: (open: boolean) => void;
	onConfirm: () => void;
}

export const ConfirmDeleteDialog = ({ open, title, children, onOpenChange, onConfirm }: ConfirmDeleteDialogProps) => (
	<AlertDialog open={open} onOpenChange={onOpenChange}>
		<AlertDialogContent>
			<AlertDialogHeader>
				<AlertDialogTitle>{title}</AlertDialogTitle>
				<AlertDialogDescription>{children}</AlertDialogDescription>
			</AlertDialogHeader>
			<AlertDialogFooter>
				<AlertDialogCancel>Cancel</AlertDialogCancel>
				<AlertDialogAction onClick={onConfirm}>Delete</AlertDialogAction>
			</AlertDialogFooter>
		</AlertDialogContent>
	</AlertDialog>
);
